// extracted by mini-css-extract-plugin
export default {"container":"EM-z","innerContainer":"FM-z","multipleLines":"GM-z","heading":"HM-z","content":"IM-z","linkColor":"JM-z"};